import React from 'react';
import { useState, useRef } from 'react';
import '../../assets/css/style.css'
import '../../assets/css/bootstrap.min.css'
import image1 from '../../assets/images/banner/playstore1.png';
import image2 from '../../assets/images/banner/playstore.avif';
import AppStore from '../../assets/images/banner/AppStore.avif';
import { contactData } from '../../utils';

const ComingSoonToast = ({ visible, onClose }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: visible ? 'auto' : 'none',
        backdropFilter: visible ? 'blur(6px)' : 'blur(0px)',
        WebkitBackdropFilter: visible ? 'blur(6px)' : 'blur(0px)',
        background: visible ? 'rgba(0, 0, 0, 0.15)' : 'transparent',
        transition: 'backdrop-filter 0.3s ease, background 0.3s ease',
      }}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
          border: '1px solid #a8d5b5',
          borderRadius: '16px',
          padding: '1.5rem 1.75rem',
          width: '320px',
          boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
          opacity: visible ? 1 : 0,
          transform: visible ? 'scale(1)' : 'scale(0.92)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <div
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '50%',
              background: 'rgba(46,125,79,0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <i className="fa-brands fa-apple" style={{ fontSize: '22px', color: '#2e7d4f' }}></i>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ fontSize: '15px', fontWeight: 700, margin: '0 0 4px', color: '#1a5c32' }}>
              Coming Soon!
            </p>
            <p style={{ fontSize: '13px', color: '#3a7a52', margin: 0 }}>
              &nbsp;The iOS app is on its way. Stay tuned!
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '2px',
              color: '#2e7d4f',
              lineHeight: 1,
              flexShrink: 0,
            }}
            aria-label="Close"
          >
            <i className="fa-solid fa-xmark" style={{ fontSize: '18px' }}></i>
          </button>
        </div>

        {/* Progress bar */}
        <div
          style={{
            marginTop: '14px',
            height: '4px',
            background: 'rgba(46,125,79,0.15)',
            borderRadius: '2px',
            overflow: 'hidden',
          }}
        >
          <div
            key={visible ? 'active' : 'idle'}
            style={{
              height: '100%',
              background: '#2e7d4f',
              borderRadius: '2px',
              width: visible ? '0%' : '100%',
              transition: visible ? 'width 4s linear' : 'none',
            }}
          />
        </div>
      </div>
    </div>
  );
};

const Footer = () => {
  const [toastVisible, setToastVisible] = useState(false);
  const timerRef = useRef(null);

  const handleAppStoreClick = (e) => {
    e.preventDefault();
    if (timerRef.current) clearTimeout(timerRef.current);
    setToastVisible(true);
    timerRef.current = setTimeout(() => setToastVisible(false), 2000);
  };

  const handleToastClose = () => {
    setToastVisible(false);
    if (timerRef.current) clearTimeout(timerRef.current);
  };


  return (
    <>
    <footer className="footer bg-image">
      <div className="container">
        <div className="pt-30 pb-30">
          <div className="row g-4">
            <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".2s">
              <div className="footer__item">
                <div className="footer__item-title">
                  <h4 className="text-white">about Encoraa ESG</h4>
                  <span className="footer__item-title-line"></span><span className="footer__item-title-line2"></span>
                </div>
                <p className="text-white">
                  ENCORRA ESG, the sustainability subsidiary of ImageIO, provides comprehensive solutions in the ESG practise to enable organizations, groups and individuals to understand, assess, implement and achieve a positive footprint in the goals and regulations established by the authorities.
                </p>
              </div>
            </div>
            <div className="col-xl-2 col-md-6 wow fadeInUp" data-wow-duration="1.4s" data-wow-delay=".4s">
              <div className="footer__item">
                <div className="footer__item-title">
                  <h4 className="text-white">Get in touch!</h4>
                  <span className="footer__item-title-line"></span><span className="footer__item-title-line2"></span>
                </div>
                <ul>
                  <li className="pb-3">
                    <a href={contactData.address.href} target="_blank" rel="noreferrer" className="text-white"><i className="fa-solid fa-location-dot pe-1 primary-color"></i>
                      {/* 407 Payal Complex, <br/>B/s VSE, Sayajigunj, <br /> Vadodara-390005 */}
                      {contactData.address.title}
                    </a>
                  </li>
                  <li className="pb-3">
                    <a href={contactData.phone.href} className="text-white" ><i className="fa-solid fa-phone-volume pe-1 primary-color"></i>
                      {contactData.phone.title}
                    </a>
                  </li>
                  <li>
                    <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info@encoraa.com" target="_blank" rel="noreferrer" className="text-white" >
                      <i className="fa-solid fa-envelope pe-1 primary-color"></i>
                      {contactData.email.title}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-2 col-md-6 wow fadeInUp" data-wow-duration="1.6s" data-wow-delay=".6s">
              <div className="footer__item">
                <div className="footer__item-title">
                  <h4 className="text-white">Quick Link</h4>
                  <span className="footer__item-title-line"></span><span className="footer__item-title-line2"></span>
                </div>
                <ul>
                  <li className="pb-2">
                    <a href="/termsandconditions" className="text-white"><i className="fa-solid fa-chevron-right pe-1 primary-color"></i>
                      Terms And Conditions
                    </a>
                  </li>
                  <li className="pb-2">
                    <a href="/privacypolicy" className="text-white"><i className="fa-solid fa-chevron-right pe-1 primary-color"></i>
                      Privacy Policy
                    </a>
                  </li>
                  <br />
                  {/* <li className='pb-5'>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.encoraa.treemetric&hl=en_IN"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={image1}
                        alt="Get it on Google Play"
                        width="155"
                        height="155" 
                        style={{ cursor: "pointer" }}
                      />
                    </a>
                  </li> */}

                  {/* <li className="pb-2">
                    <a href="/" className="text-white"><i className="fa-solid fa-chevron-right pe-1 primary-color"></i>
                      Water Conservation
                    </a>
                  </li>
                  <li className="pb-2">
                    <a href="/" className="text-white"><i className="fa-solid fa-chevron-right pe-1 primary-color"></i>
                      Eco System
                    </a>
                  </li>
                  <li className="pb-2">
                    <a href="/" className="text-white"><i className="fa-solid fa-chevron-right pe-1 primary-color"></i>
                      Plastic Recycling
                    </a>
                  </li>
                  <li className="pb-2">
                    <a href="/" className="text-white"><i className="fa-solid fa-chevron-right pe-1 primary-color"></i>
                      Urban Planning
                    </a>
                  </li>
                  <li>
                    <a href="/" className="text-white"><i className="fa-solid fa-chevron-right pe-1 primary-color"></i>
                      Save Green House
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 wow fadeInUp" data-wow-duration="1.8s" data-wow-delay=".8s">
              <div className="footer__item">
                <div className="footer__item-title">
                  <h4 className="text-white">Mobile Apps</h4>
                  <span className="footer__item-title-line"></span><span className="footer__item-title-line2"></span>
                </div>
                <ul className="footer__item-blog ">
                  <li className="pb-3">
                    <a
                      title="Open on Play Store"
                      href="https://play.google.com/store/apps/details?id=com.encoraa.treemetric&hl=en_IN"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={image2}
                        alt="Get it on Google Play"
                        width="155"
                        height="155"
                        style={{ cursor: "pointer",objectFit: "cover" }}
                      />
                    </a>
                  </li>

                  <li className="pb-3">
                    <a
                      title="Coming Soon"
                      href="#"
                      onClick={handleAppStoreClick}
                      rel="noopener noreferrer"
                    >
                      <img
                        src={AppStore}
                        alt="Get it on App Store"
                        width="155"
                        height="155"
                        style={{ cursor: "pointer",objectFit: "cover" }}
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer__copyright">
        <p>
          &copy; Copyright {new Date().getFullYear()}{" "}
          <a href="#0">ImageIO</a> All Rights Reserved
        </p>
      </div>
    </footer>
     <ComingSoonToast visible={toastVisible} onClose={handleToastClose} />
     </>
  );
};

export default Footer;
